export default __webpack_public_path__ + "static/jquery-35687998632144f7a73dbc7b4a439cf8.png";